"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cssHelper = require("css");
const utils_array_1 = require("@agilepoint/utils-array");
const utils_common_1 = require("@agilepoint/utils-common");
const styled_components_1 = require("styled-components");
exports.getFormattedCssClasses = utils_common_1.memoizeFunction((classes) => {
    return classes.split(',').reduce((prev, next) => {
        prev[next] = true;
        return prev;
    }, {});
});
function getRuleListWithSelectors(stylesheet) {
    return stylesheet.rules.filter((rule) => (rule.selectors && rule.selectors.length > 0));
}
function scopifySelectorInRule(parentSelector, rule) {
    return utils_array_1.mapSeries(rule.selectors, (selector) => Promise.resolve(`${parentSelector} ${selector}`)).then((selectors) => {
        rule.selectors = selectors;
        return rule;
    });
}
function getScopifiedCss(css, parentSelector) {
    const { stylesheet } = css;
    const ruleListWithSelectors = getRuleListWithSelectors(stylesheet);
    return utils_array_1.mapSeries(ruleListWithSelectors, scopifySelectorInRule.bind(css, parentSelector)).then(() => {
        return cssHelper.stringify(css);
    });
}
function isStyleSheetValid(css) {
    const { stylesheet } = css;
    return (!!stylesheet && (stylesheet.parsingErrors === undefined || stylesheet.parsingErrors.length === 0));
}
function scopifyCss(cssContent, parentSelector) {
    const css = cssHelper.parse(cssContent, { silent: true });
    if (!isStyleSheetValid(css)) {
        return Promise.resolve('');
    }
    return getScopifiedCss(css, parentSelector);
}
exports.scopifyCss = scopifyCss;
function extractClassNameFromSelectorString(selectorString) {
    return selectorString.replace('.', '');
}
const classNameRegex = /[.]+[_a-zA-Z0-9-]*/g;
function getClassNamesFromSelector(classNameList, selector) {
    const matchedCssClassSelectors = selector.match(classNameRegex);
    if (!matchedCssClassSelectors || matchedCssClassSelectors.length === 0) {
        return Promise.resolve(classNameList);
    }
    return Promise.resolve(classNameList.concat(matchedCssClassSelectors.map(extractClassNameFromSelectorString)));
}
function getClassNamesFromRule(rule) {
    return utils_array_1.reduceSeries(rule.selectors, getClassNamesFromSelector, []);
}
function getAllClassNamesFromCss(css) {
    const ruleListWithSelectors = getRuleListWithSelectors(css.stylesheet);
    return utils_array_1.reduceSeries(ruleListWithSelectors, async (classNameList, rule) => getClassNamesFromRule(rule).then((res) => classNameList.concat(res)), []);
}
function getClassesFromCSS(cssContent = '') {
    const css = cssHelper.parse(cssContent, { silent: true });
    if (!isStyleSheetValid(css)) {
        return Promise.resolve([]);
    }
    return getAllClassNamesFromCss(css).then(classNames => utils_array_1.unique(classNames));
}
exports.getClassesFromCSS = getClassesFromCSS;
function usingCssSnippets(target, cssSnippets, attributes) {
    if (attributes !== undefined) {
        return styled_components_1.default(target).attrs(() => ({
            ...attributes
        })) `
        ${cssSnippets}
        `;
    }
    return styled_components_1.default(target) `
        ${cssSnippets}
        `;
}
exports.usingCssSnippets = usingCssSnippets;
//# sourceMappingURL=css-utilities.js.map